import { ConditionalViewRenderer } from '@ulta/core/components/ConditionalViewRenderer/ConditionalViewRenderer';

export default ConditionalViewRenderer;